import { gql } from '@apollo/client';
import { ecommerceResult } from './query';

export const ECOMMERCE_ADD_COMPARISON = gql`
  mutation EcommerceComparison_addComparison(
    $projectId: Id!
    $comparisonName: String!
    $comparisonGroups: [ComparisonGroupInput!]!
    $sourceType: SourceType!
  ) {
    ecommerceComparison_addComparison(
      projectId: $projectId
      comparisonName: $comparisonName
      comparisonGroups: $comparisonGroups
      sourceType: $sourceType
    ) {
      id
      namespace
      displayName
      createdAt
      groups {
        id
        name
        color
        displayName
        createdAt
        objectGroup {
          id
          name
          displayName
          createdAt
          objectList {
            id
            socialMedia
            streamType
            content
            extraContent
            objectName
            isHashtag
            createdAt
            openApiId
            displayPicture
            includes
            excludes
            languages
            isEntity
            entityName
            isAuthorizeTiktok
          }
        }
        objectList {
          id
          socialMedia
          streamType
          content
          extraContent
          objectName
          isHashtag
          createdAt
          openApiId
          displayPicture
          includes
          excludes
          languages
        }
        labelList {
          id
          name
          displayName
          colorType
          isActive
          createdAt
        }
      }
      colors
    }
  }
`;

export const MANAGE_VISIBILITY_ON_ECOMMERE_STREAM = gql`
  mutation ecommerce_manageVisibilityOnStreams(
    $projectId: Id!
    $objectAndStream: [ObjectAndStreamListInput!]!
    $visibility: Visibility!
  ) {
    ecommerce_manageVisibilityOnStreams(
      projectId: $projectId
      objectAndStream: $objectAndStream
      visibility: $visibility
    ) {
      ${ecommerceResult}
    }
  }
`;
